import { Link } from "react-router-dom";
import ProductAssemblyCatalogue from "../components/ProductAssemblyCatalogue";
import ScrollElevate from "../components/ScrollElevate";
import "../styles/catalogue-page.css";
import "../styles/scroll-elevate.css";
import { BtnContent } from "../components/BtnIcon";
import { IoChatbubbleEllipsesOutline, IoStorefrontOutline } from "react-icons/io5";

/** Full-page gift box assembly instructions (infographic image). */
export default function Catalogue() {
  return (
    <div className="catalogue-page">
      <div className="catalogue-page__inner container">
        <ScrollElevate>
          <header className="catalogue-page__head">
            <h1 className="catalogue-page__title">Assembly instructions</h1>
            <p className="catalogue-page__lead">
              Step-by-step guide for folding, sealing, and tying your Rencin Gifting box.
            </p>
          </header>
        </ScrollElevate>

        <ScrollElevate delay={0.1}>
          <ProductAssemblyCatalogue />
        </ScrollElevate>

        <ScrollElevate delay={0.15} className="catalogue-page__actions-wrap">
        <div className="catalogue-page__actions">
          <Link to="/shop" className="btn btn-dark px-4">
            <BtnContent icon={IoStorefrontOutline}>Shop gift boxes</BtnContent>
          </Link>
          <Link to="/customise" className="btn btn-outline-dark px-4">
            <BtnContent icon={IoChatbubbleEllipsesOutline}>Customise a gift box message</BtnContent>
          </Link>
        </div>
        </ScrollElevate>
      </div>
    </div>
  );
}
